import useEntities from 'hooks/useEntities';
import RelationsEditable from 'components/RelationsEditable';

const DisciplinaryPlayers = ({ sourceEntityId, data, onChange }) => {
    const entities = useEntities();
    const sourceEntity = entities.Disciplinary;
    const targetEntity = entities.Player;

    return (
        <RelationsEditable 
            data={data}
            sourceEntity={sourceEntity} 
            targetEntity={targetEntity}
            sourceEntityId={sourceEntityId}
            // targetEntityFilters={{status: ['ACTIVE', 'INACTIVE', 'RETIRED', 'UNKNOWN']}}
            emptyMessage={`This ${sourceEntity.displayName} does not have any ${targetEntity.displayNamePlural}`}
            onChange={onChange}
        />
    )
}

export default DisciplinaryPlayers
